/*eslint-disable*/
import React, { useEffect, useState } from 'react'
import { Header, Segment, } from 'semantic-ui-react'
import LoadingPlaceholder from '../../placeholderComponent/loadingPlaceholder'
import ReadAxios from '../../axiosComponent/read'
import AgGridTable from '../../agGridComponent/agGridTable';
import { FEATURES } from '../../../utils/constants';


function ChecklistTable(props) {
    const [checklistParticulars, setchecklistParticulars] = useState([])
    const [isLoaded, setisLoaded] = useState(false)
    const [isUpdated, setisUpdated] = useState(false)
    useEffect(() => {
        getData()
    }, [isUpdated])

    let getData = () => {
        ReadAxios({ url: 'checklist/getCheckListParticulars' }).then((result) => {
            setchecklistParticulars(result)
            setisLoaded(true)
        })
    }
    let getUpdate = (data) => {
        if (data) {
            setisUpdated(!isUpdated)
        }
    }
    if (branches.length === 0 && isLoaded === false) {
        return (
            <LoadingPlaceholder />
        )
    } else if (branches.length === 0) {
        return (
            <Segment className="m-2">
                <center> <Header>NO Record(s) Found</Header></center>
            </Segment>
        )
    } else {

        let columnDefs = [
            { headerName: 'Checklist Particular Name', field: 'code', tooltipField: 'code', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Branch Name', field: 'name', tooltipField: 'name', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Created By', field: 'cby', tooltipField: 'cby', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Created Date', field: 'cdate', tooltipField: 'cdate', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Updated By', field: 'uby', tooltipField: 'uby', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Updated Date', field: 'udate', tooltipField: 'udate', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Edit / Delete', field: 'edit', cellRenderer: 'actionRenderer', suppressToolPanel: true, },
        ]
        let rowData = []
        checklistParticulars.map((object, i) => {
            let temp = {}
            // temp.code = object.branchCode.toUpperCase()
            // temp.name = object.branchName
            // temp.cby = object.createdByName
            // temp.id = object.branchId
            // temp.cdate = object.createdOn
            // temp.uby = object.updatedByName
            // temp.udate = object.updatedOn
            // temp.isGSTExempted = object.isGSTExempted
            // temp.customerNo = object.customerNo
            // temp.url = 'branch/delete'
            // temp.deleteId = { branchId: object.branchId }
            // rowData[i] = temp
        })
        return (
            <React.Fragment >
                <AgGridTable
                    columnDefs={columnDefs}
                    rowData={rowData}
                    searchValue={props.searchValue}
                    actionButton={ActionButton}
                    reload={getUpdate}
                    link="#"
                    hiddenNew={true}
                    newPopup={props.newPopup}
                    titleBarTitle="Branch"
                    handleSearch={props.handleSearch}
                    hiddenImportPopupBtn={true}
                    exportHidden={FEATURES.mastersExportDisabled()}
                    suppressExcelExport={FEATURES.mastersExportDisabled()}
                    suppressCsvExport={FEATURES.mastersExportDisabled()}
                />
            </React.Fragment>
        )
    }

}

export default ChecklistTable
